export default __webpack_public_path__ + "static/2239-801a2934be61c8c241073b853a230391.gif";